import { MinusIcon, Mtds, PlusIcon } from 'prove-common'

type QuantityStepperProps = {
  value: number
  onChange: (value: number) => void
  /** Laveste tillatte antall. */
  min?: number
  disabled?: boolean
  label: string
  id?: string
  className?: string
}

/**
 * Antallsvelger med minus- og plussknapp rundt et tallfelt.
 */
export const QuantityStepper = ({
  value,
  onChange,
  min = 0,
  disabled = false,
  label,
  id,
  className
}: Readonly<QuantityStepperProps>) => {
  const update = (next: number): void => {
    if (!Number.isFinite(next)) return
    onChange(Math.max(min, next))
  }
  return (
    <Mtds.Flex data-nowrap data-gap={2} className={className}>
      <Mtds.Button
        aria-label={`Færre – ${label}`}
        data-tooltip='Færre'
        data-variant='tertiary'
        className='bg-neutral-surface-tinted shrink-0'
        onClick={() => update(value - 1)}
        disabled={disabled || value <= min}
      >
        <MinusIcon />
      </Mtds.Button>
      <Mtds.Input
        aria-label={label}
        id={id}
        className='min-w-0 flex-1 text-center'
        onChange={({ target }) => update(Number(target.value))}
        type='number'
        min={min}
        step={1}
        value={value}
        disabled={disabled}
      />
      <Mtds.Button
        aria-label={`Flere – ${label}`}
        data-tooltip='Flere'
        data-variant='tertiary'
        className='bg-neutral-surface-tinted shrink-0'
        onClick={() => update(value + 1)}
        disabled={disabled}
      >
        <PlusIcon />
      </Mtds.Button>
    </Mtds.Flex>
  )
}
